<template id="">
  <div
    class="modal-order-info"
    :class="getOrderVariant()"
    v-on:mouseover="mouseOver"
    v-on:mouseleave="mouseOut"
    v-on:click="clickHandler"
  >
    <div v-if="!isOpen" class="general-detail fit-content">
      <div class="symbol-container">
        <span class="title">
          {{ toSymbolName(selectedDetail.symbol) }}
        </span>
        <strong>{{
          selectedDetail.side === 1 ? $t('order.buy') : $t('order.sell')
        }}</strong>
      </div>
      <div>
        <div class="row-direction fit-content">
          <span class="row-label">{{
            selectedDetail.order_type !== 2
              ? $t('order.average-price')
              : $t('order.unit-price')
          }}</span>
          <!--          <span>{{ selectedDetail.unit_price | currency('', '₮') }}</span>-->
          <span v-if="selectedDetail.order_type !== 2">{{
            this.averagePrice | currency('', '₮')
          }}</span>
          <span v-else>{{
            selectedDetail.unit_price | currency('', '₮')
          }}</span>
        </div>
        <div class="row-direction fit-content">
          <span class="row-label">{{ $t('order.quantity') }}</span>
          <span>{{ selectedDetail.quantity | amount }}</span>
        </div>
        <div class="row-direction fit-content">
          <span class="row-label">{{ $t('order.amount') }}</span>
          <span>{{ selectedDetail.order_amount | currency('', '₮') }}</span>
        </div>
        <div class="row-direction fit-content">
          <span class="row-label">{{ $t('order.fee') }}</span>
          <span>{{ this.totalFee | currency('', '₮') }}</span>
        </div>

        <div v-if="this.variant === 'mini'" class="row-direction fit-content">
          <span class="row-label">{{ $t('brand.type.title') }}</span>
          <span>{{
            selectedDetail.order_type === 2
              ? $t('brand.type.conditional')
              : $t('brand.type.current')
          }}</span>
        </div>
        <div v-if="this.variant === 'mini'" class="row-direction fit-content">
          <span class="row-label">{{ $t('order.total-amount') }}</span>
          <span>{{ selectedDetail.total_amount | currency('', '₮') }}</span>
        </div>
        <div v-if="this.variant === 'mini'" class="row-direction fit-content">
          <span class="row-label">{{ $t('order.status') }}</span>
          <span>{{ $t('order.state.' + selectedDetail.exec_type) }}</span>
        </div>
        <div v-if="this.variant === 'mini'" class="row-direction fit-content">
          <span class="row-label">{{ $t('order.created_at') }}</span>
          <span>{{ selectedDetail.created_at | formatDate }}</span>
        </div>
      </div>
    </div>
    <div v-if="this.variant === 'normal'" class="zigzag" />
    <div v-if="this.variant === 'normal'" class="additional-detail">
      <div class="row-direction fit-content">
        <span class="row-label">{{ $t('brand.type.title') }}</span>
        <span>{{
          selectedDetail.order_type === 2
            ? $t('brand.type.conditional')
            : $t('brand.type.current')
        }}</span>
      </div>
      <div class="row-direction fit-content">
        <span class="row-label">{{ $t('order.total-amount') }}</span>
        <span>{{ selectedDetail.total_amount | currency('', '₮') }}</span>
      </div>
      <div class="row-direction fit-content">
        <span class="row-label">{{ $t('order.status') }}</span>
        <span>{{ $t('order.state.' + selectedDetail.exec_type) }}</span>
      </div>
      <div class="row-direction fit-content">
        <span class="row-label">{{ $t('order.created_at') }}</span>
        <span>{{ selectedDetail.created_at | formatDate }}</span>
      </div>
      <div class="row-direction pt-3">
        <b-button
          v-if="isOrder"
          v-b-tooltip.top
          class="cancel-button p2r"
          :disabled="isCancelDisabled(selectedDetail)"
          variant="danger"
          size="sm"
          :title="$t('helper.cancel')"
          @click="cancelOrder(selectedDetail)"
          ><span
            ><i class="fas fa-trash"></i>
            {{
              $t('helper.slotted-cancel', { slot: $tc('order.order', 1) })
            }}</span
          >
        </b-button>
      </div>
    </div>

    <div
      v-if="tableDisplayable"
      class="order-detail-table p-3 animate__animated animate__flipInX"
    >
      <table class="table orders-table">
        <thead>
          <th class="text-center">№</th>
          <th class="text-center">{{ $t('order.price') }}</th>
          <th class="text-center">{{ $t('order.quantity') }}</th>
          <th class="text-center">{{ $t('order.remaining') }}</th>
          <th class="text-center">{{ $t('order.created_at') }}</th>
        </thead>
        <tbody v-for="(detail, i) in selectedDetail.order_details" :key="i">
          <td class="text-center" :variant="detail.text ? 'danger' : ''">
            {{ i + 1 }}
          </td>
          <td class="text-center" v-if="!detail.text">{{ detail.last_px }}</td>
          <td class="text-center" v-if="!detail.text">{{ detail.last_qty }}</td>
          <td class="text-center" v-if="!detail.text">
            {{ detail.leaves_qty }}
          </td>
          <td class="text-center" v-if="!detail.text">
            {{ detail.created_at | formatDate }}
          </td>
          <td class="text-center" v-else colspan="4" variant="danger">
            {{ detail.text }}
          </td>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style lang="scss" src="../../sass/trade/order_detail.scss"></style>

<script>
import { ExecType } from '../constants'

export default {
  props: {
    selectedDetail: {
      type: Object,
      required: true,
    },
    cancelOrder: {
      type: Function,
      required: true,
    },
    isOrder: {
      type: Boolean,
      required: true,
    },
    variant: {
      type: String,
      required: false,
      default: 'normal',
    },
  },
  mounted() {},
  data() {
    return {
      ExecType,
      isOpen: false,
    }
  },
  methods: {
    mouseOver() {
      if (this.$mq === 'desktop' && this.variant === 'mini') this.isOpen = true
    },
    mouseOut() {
      if (this.$mq === 'desktop') this.isOpen = false
    },
    clickHandler() {
      this.isOpen = !this.isOpen
    },
    getOrderVariant() {
      if (this.variant === 'mini')
        return (
          'mini-order item-' + ExecType[this.selectedDetail.exec_type].variant
        )
      return 'item-' + ExecType[this.selectedDetail.exec_type].variant
    },
    isCancelDisabled(brand) {
      // return (
      //   (brand.sent === 3 && brand.exec_type === 'P') ||
      //   this.disabledList.includes(brand.exec_type)
      // )
      return false
    },
    toSymbolName(symbol) {
      if (!symbol) return
      return !symbol.split('').includes('-')
        ? symbol
        : symbol
            .split('')
            .splice(
              0,
              symbol.split('').findIndex((x) => x === '-')
            )
            .join('')
            .toString()
    },
  },
  computed: {
    disabledList() {
      return ['4', 'C', '8', '6', 'F']
    },
    averagePrice() {
      let averagePrice = 0
      let total = 0
      this.selectedDetail.order_details.forEach((item) => {
        averagePrice += parseFloat(item.last_px) * parseFloat(item.last_qty)
        total += parseFloat(item.last_qty)
      })
      averagePrice /= total
      return averagePrice > 0 ? averagePrice : 0
    },
    tableDisplayable() {
      return this.isOpen && this.selectedDetail.order_details
    },
    totalFee() {
      let totalFee = 0
      this.selectedDetail.order_details.forEach((item) => {
        totalFee += parseFloat(item.fee)
      })
      return totalFee > 0 ? totalFee : 0
    },
  },
}
</script>
